import { type OrganicStat } from "../../gql-generated/types";
import { type GetOrganicStatsQuery } from "../api/queries";

import { getStatsResponseTimeEntryList } from "./getStatsResponseTimeEntryList";

export const getStatsTotal = (
    data: GetOrganicStatsQuery | undefined,
    filterFn?: (stat: OrganicStat) => boolean,
): number => {
    if (!data) {
        return Number.NaN;
    }
    const statTotal = (getStatsResponseTimeEntryList(data)[0]?.statsList[0]?.statsList ?? [])
        .filter((stat) => (filterFn ? filterFn(stat) : true))
        .reduce((acc, stat) => acc + Number(stat.value), 0);
    return statTotal;
};
